import React from "react";
import { string } from "prop-types";

import LoadingIndicator from "../../../../shared/seller-services/components/LoadingIndicator";
import ValuationContainer from "../ValuationContainer";
import * as S from "./styled";

const ValuationLoading = ({ className }) => (
  <ValuationContainer className={className}>
    <S.LoadingContainer>
      <LoadingIndicator />
    </S.LoadingContainer>
  </ValuationContainer>
);

ValuationLoading.propTypes = {
  className: string
};

ValuationLoading.defaultProps = {
  className: ""
};

export default ValuationLoading;
